module.exports = __webpack_public_path__ + "img/pres-05.356027c2.png";